import { useState } from 'react';
import { Button } from '@mui/material';
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { PostcodeEditDialog } from '../../Admin/Postcode/PostcodeEditDialog';
import { IPostcode as IAdminPostcode } from '../../hooks/reactQuerys/PostcodeAdminQueries';
import { IPostcode } from '../../Interfaces/IPostcode';

interface IProps {
  /** Vorbelegung aus dem Dialog (PLZ/Ort), damit der Mitarbeiter nur bestätigen muss. */
  prefillPostcode?: string;
  prefillCity?: string;
  /** Wird mit der neu angelegten PLZ (Import-Form) aufgerufen. */
  onCreated: (postcode: IPostcode) => void;
}

/**
 * „Fehlende PLZ anlegen" im Importbereich: öffnet den regulären PLZ-Anlegedialog
 * (inkl. Fünf-Ziffern-Prüfung für Deutschland, Land/Bundesland und
 * Dublettenschutz) und übernimmt die neue PLZ direkt in die PLZ-Absicherung.
 */
export const CreateMissingPostcode = ({
  prefillPostcode,
  prefillCity,
  onCreated,
}: IProps) => {
  const [open, setOpen] = useState(false);

  const initial =
    prefillPostcode || prefillCity
      ? ({
          Postcode: prefillPostcode ?? '',
          City: prefillCity ?? '',
        } as IAdminPostcode)
      : null;

  return (
    <>
      <Button
        size='small'
        startIcon={<AddLocationAltIcon />}
        onClick={() => setOpen(true)}
        sx={{ mt: 0.5 }}
      >
        Fehlende PLZ anlegen
      </Button>
      <PostcodeEditDialog
        open={open}
        mode='create'
        initial={initial}
        onClose={() => setOpen(false)}
        onSaved={() => {}}
        onCreated={created => {
          onCreated({
            idPostcode: created.idPostcode,
            Postcode: created.Postcode,
            City: (created.City ?? '').trim(),
            idCountry: created.Country_idCountry ?? null,
          });
          setOpen(false);
        }}
      />
    </>
  );
};
